import { Component } from "@angular/core";
import { BaseComponent } from "../../base.component";
import { LoadingController, NavController, ToastController } from "@ionic/angular";
import { LoginService } from "src/app/shared/service/login/login.service";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "src/environments/environment";

@Component({
  selector: 'cmp-confirmar-cadastro',
  templateUrl: './confirmar-cadastro.component.html',
  styleUrls: [
    './confirmar-cadastro.component.scss',
  ]
})
export class ConfirmarCadastroComponent extends BaseComponent{
  theme = environment.theme_name;
  id!: any;
  celular!: any;
  codigo!: string;

  reenviarCountdown = 60;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public toastController: ToastController, 
    public loadingController: LoadingController,
    protected navCtrl: NavController,
    protected service: LoginService) {
      super(router, toastController, loadingController);
      this.route.queryParams.subscribe((params) => {
        this.id = params['id'];
        this.celular = params['celular'];
      });
      this.startReenviarCountdown();
    }

  confirmar(){
    this.openLoading('Carregando...');
    this.service.confirmar(this.celular, this.codigo).then((resultado) => {
        this.login();
    }).catch((ex) =>{
      if(ex.error)
        this.message(ex.error.msg);
    }).finally(() =>{
      this.closeLoading();
    })
  }

  reenvio(){
    if(this.reenviarCountdown > 0){
      return;
    }

    this.openLoading('Carregando...');
    this.service.reenvio(this.id, this.celular).then((resultado) => {
      if(resultado.ok)
        this.message(resultado.msg);
      else if(resultado.msg)
        this.message(resultado.msg);
    }).catch((ex) =>{
      console.log(ex);
    }).finally(() =>{
      this.closeLoading();
    })
  }
  
  login(){
    this.navCtrl.navigateForward('/onboarding/login');
  }

  startReenviarCountdown(){
    this.reenviarCountdown = 60;
    const interval = setInterval(() => {
      this.reenviarCountdown--;
      if(this.reenviarCountdown < 0){
        this.reenviarCountdown = 0;
        clearInterval(interval);
      }
    }, 1000);
  }
}
